import { render } from "./ButtonLinkForm.vue?vue&type=template&id=e65b58c6&scoped=true"
import script from "./ButtonLinkForm.vue?vue&type=script&lang=js"
export * from "./ButtonLinkForm.vue?vue&type=script&lang=js"

import "./ButtonLinkForm.vue?vue&type=style&index=0&id=e65b58c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e65b58c6"]])

export default __exports__